import React from 'react';

export const ProductNotFound: React.FC = () => {
  return <span className="ProductNotFound">Oops, product was not found</span>;
};
